import React, { useState, useRef, useEffect } from 'react';
import { ApiCore } from '../../../api/index';
import { Switch, Toast, Button, InfiniteScroll } from 'antd-mobile-v5';
import { withRouter } from 'react-router-dom';
import NoRecord from '../../component/noRecord';
import styles from './index.module.scss';
import DetailPatientAvatar from '../../../static/images_cso/detail_patient_avatar.png';
import suggested from '../../../static/images_cso/suggested.png';
import payed from '../../../static/images_cso/payed.png';
import recieved from '../../../static/images_cso/recieved.png';
import closed from '../../../static/images_cso/closed.png';
import refund from '../../../static/images_cso/refund.png';
import methods from '../../../utils/methods';

const api = new ApiCore();

const mTabs = [
    {state: 0, text: '全部'}, 
    {state: 10, text: '已建议'}, 
    {state: 51, text: '已支付'},
    {state: 52, text: '已拒绝'},
    {state: 60, text: '已收货'},
    {state: 99, text: '已关闭'} 
]

const stateMap = {
    10: '已建议',
    51: '已支付',
    52: '已拒绝',
    60: '已收货',
    99: '已关闭'
};

const PatientDetail = (props: any) => {

    const [patientInfo, setPatientInfo] = useState<any>({});
    const [scrollReady, setScrollReady] = useState<any>(false);
    const [tabs, setTabs] = useState<any>(mTabs);
    const [activeTabIndex, setActiveTabIndex] = useState<any>(0);
    const [nowState, setNowState] = useState<any>(0);
    const [isMore, setIsMore] = useState<any>(true);
    const [page, setPage] = useState<any>(0);
    const [pageSize, setPageSize] = useState<any>(10);
    const [list, setList] = useState<any>([]);
    const [total, setTotal] = useState<any>(null);
    const [listReady, setListReady] = useState<any>(false);

    useEffect(() => {
        let cso_patient_info = sessionStorage.getItem('cso_patient_detail_info');
        if (cso_patient_info) {
            let patientInfo = JSON.parse(cso_patient_info);
            setPatientInfo(patientInfo);
            getPatientData(patientInfo);
        }
        return () => {
        }
    }, [])

    useEffect(() => {
        if (patientInfo && Object.keys(patientInfo).length > 0) {
            setScrollReady(true);
        }
    }, [patientInfo])

    const getPatientData = (patientInfo: any) => {
        api.getDoctorsPatientsDetail({
            patientCode: patientInfo.patientCode
        }).then((res: any) => {
            if (res.code == 0) {
                const _data = res.data || {};
                let age = methods.getAgeByBirth(_data.birthDate)
                setPatientInfo({ ..._data, age});
            }
        })
    }

    const getListData = (patientInfo: any, state?: any, mPage?: number) => {
        const mState = state ? {
            state
        }: {};
        let _page = mPage ? mPage : page;
        setListReady(false);
        api.getDoctorsPatientRecordList({
            projectCode: patientInfo.projectCode,
            patientCode: patientInfo.patientCode,
            page: _page,
            pageSize: pageSize,
            ...mState
        }).then((res: any) => {
            if (res.code == 0) {
                const _dataRows = res.data?.rows || [];
                let _list = _page == 1 ? _dataRows : list.concat(_dataRows);
                setTotal(res.data?.total)
                setIsMore(_list.length < res.data.total);
                setList(_list);
                setListReady(true);
            }
        })
    }

    const getData = () => {
        return new Promise<any>((resolve, reject) => {
            if (total !== null && page * pageSize >= total) {
                setIsMore(false);
                resolve([]);
            }
            let _page = page;
            const mState = nowState ? {
                state: nowState
            }: {};
            _page++;
            setPage(_page)
            api.getDoctorsPatientRecordList({
                projectCode: patientInfo.projectCode,
                patientCode: patientInfo.patientCode,
                page: _page,
                pageSize: pageSize,
                ...mState
            }).then((res: any) => {
                if (res.code == 0) {
                    setTotal(res.data?.total)
                    if (_page * pageSize >= res.data?.total) {
                        setIsMore(false);
                    }
                    resolve(res.data?.rows);
                }
            })
        })
    }

    async function loadMore() {
        setListReady(false);
        const append = await getData();
        setList((val: any) => [...val, ...append]);
        setListReady(true);
    }

    const itemClick = (val: any) => {

    }

    const tabBarActive = (val: any, key: number) => {
        setActiveTabIndex(key)
        setNowState(val.state);
        setPage(1);
        getListData(patientInfo, val.state, 1);

    }

    const renderColorClass = (val: any) => {
        const state = val.state;
        if (state == 10) {
            return styles.suggested;
        } else if (state == 51) {
            return styles.payed;
        } else if (state == 60) {
            return styles.recieved;
        } else if (state == 52) {
            return styles.refund; // 已拒绝
        } else if (state == 99) {
            return styles.closed;
        }
    }

    const renderImg = (val: any) => {
        const state = val.state;
        if (state == 10) {
            return <img src={suggested} alt="" />;
        } else if (state == 51) {
            return <img src={payed} alt="" />;
        } else if (state == 60) {
            return <img src={recieved} alt="" />;
        } else if (state == 52) {
            return <img src={refund} alt="" />;
        }  else if (state == 99) {
            return <img src={closed} alt="" />;
        }
    }

    const fakeName = (name: string) => {
        if (name) {
            if (name.length == 1) {
                return name;
            } else if (name.length == 2) {
                return name[0] + '*';
            } else {
                return name[0] + '*'.repeat(name.length - 2) + name[name.length -1];
            }
        }
        return '';
    }

    return (
        <div className={styles.patientDetail_content}>
            <div className={styles.page_container}>
                <div className={styles.head}>
                    <div className={styles.h_l}>
                        <img src={DetailPatientAvatar} alt="" />
                    </div>
                    <div className={styles.h_m}>
                        <div className={styles.h_m_t}>
                            <div className={styles.h_m_t_t}>{fakeName(patientInfo.patientName)}</div>
                            <div className={styles.h_m_t_b}>{patientInfo.projectName}</div>
                        </div>
                        <div className={styles.h_m_b}>
                            <div className={styles.h_m_b_l}>{patientInfo.phone ? patientInfo.phone.replace(/(\d{3})(\d{4})(\d{4})/, "$1 **** $3") : ''}</div>
                            <div className={styles.h_m_b_r_l}>{patientInfo.sex == '1' ? '男' : '女'}</div>
                            {
                                patientInfo.age &&
                                <>
                                    <div className={styles.h_m_b_r_line}></div>
                                    <div className={styles.h_m_b_r_r}>{patientInfo.age}岁</div>
                                </>
                            }
                        </div>
                    </div>
                    <div className={styles.h_r}>
                        <div className={styles.h_r_box}>
                            <div className={styles.b_r_box_t}><span className={styles.num}>{patientInfo.finishCount || 0}</span>单</div>
                            <div className={styles.b_r_box_b}>累计完成处方</div>
                        </div>
                    </div>
                </div>
                <div className={styles.body}>
                    <div className={styles.body_head}>
                        <div className={styles.b_t}>
                            处方建议记录
                        </div>
                        <div className={styles.b_t_tabs}>
                            {
                                tabs && tabs.map((val: any, key: number) => (
                                    <div key={key} className={`${activeTabIndex == key ? styles.active : styles.un_active}`} onClick={() => { tabBarActive(val, key) }}>
                                        {val.text}
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                    <div className={styles.body_list}>
                        {
                            list && list.map((val: any, key: number) => (
                                <div key={key} className={`${styles.list_item}`} onClick={() => { itemClick(val) }}>
                                    <div className={styles.list_item_t}>
                                        <div className={styles.list_item_t_l}>
                                            {renderImg(val)}
                                        </div>
                                        <div className={`${styles.list_item_t_m} ${renderColorClass(val)}`}>{stateMap[val.state]}</div>
                                        <div className={styles.list_item_t_r}>
                                            { 
                                                val.createTime 
                                                ?
                                                val.createTime.substring(0, 10).replace(/-/g, '').replace(/(\d{4})(\d{2})(\d{2})/, "$1年$2月$3日") + '处方'
                                                :
                                                ''
                                            }
                                        </div>
                                    </div>
                                    {
                                        val.goods && (val.goods).map((val: any, key: number) => (
                                            <div key={key}>
                                                <div className={styles.list_item_m}></div>
                                                <div className={styles.list_item_b}>
                                                    <div className={styles.list_item_b_l}>
                                                        <div className={styles.list_item_b_l_t}>{key + 1}</div>
                                                    </div>
                                                    <div className={styles.list_item_b_m}>
                                                        <div className={styles.list_item_b_m_t}>{val.drugName}</div>
                                                        <div className={styles.list_item_b_m_b}>数量：{val.num}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    }
                                    <div className={styles.list_item_m}></div>
                                    <div className={styles.patient_person}>
                                        <span>就诊人</span>
                                        <span>{fakeName(val.outPatientName)}</span>
                                        <span>{val.outPatientIdCard}</span>
                                    </div>
                                </div>
                            ))
                        }
                        { listReady &&  list.length == 0 &&
                            <NoRecord>
                                暂无记录
                            </NoRecord>
                        }
                        {
                            scrollReady ?
                            <InfiniteScroll loadMore={loadMore} hasMore={isMore} >{''}</InfiniteScroll>
                            :
                            ''
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withRouter(PatientDetail);